<script setup lang="ts">
import type { User } from "@shared/types.js";

/** Who is typing in the field beside this, in the colour and initials the rest
 *  of the board already uses for them. Renders nothing when nobody is. */
defineProps<{ user: User | null }>();
</script>

<template>
  <span
    v-if="user"
    class="avatar lock-tag"
    :style="{ background: user.color }"
    :title="`${user.displayName} is editing this`"
  >✎ {{ user.displayName.slice(0, 2) }}</span>
</template>
